import { FC } from 'react'
import Avatar from 'react-avatar'

import './style.scss'
import { utils } from '../../utils'
import { Text } from '../UI'

type ProfileViewProps = {
  className?: string,
  user: any,
  userAvatar?: string
}

const FormLabelView:FC<{ className?: string }> = ({ children, className }) => <Text component="label" color="primary" className={className}>{children}</Text>

const FormInputView:FC<{ className?: string, style?: any }> = ({ children, className = '', style }) => <span className={`profile-field-view ${className}`} style={style}>{children}</span>

const ProfileView:FC<ProfileViewProps> = ({ className = '', user, userAvatar }) => {
  return (
    <div className={className}>
      <div className="row">
        <div className="col-12 lg:col-6">
          <div>
            <Avatar
              src={userAvatar}
              className="profile-avatar"
            />
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-5 lg:pt-5 lg:pr-0">
              <FormLabelView>Nombres</FormLabelView>
            </div>
            <div className="col-12 lg:col-7 mt-5 lg:mt-0">
              <FormInputView>{user.first_name}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-5 lg:pt-5 lg:pr-0">
              <FormLabelView>Primer apellido</FormLabelView>
            </div>
            <div className="col-12 lg:col-7 mt-5 lg:mt-0">
              <FormInputView>{user.last_name}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-5 lg:pt-5 lg:pr-0">
              <FormLabelView>Segundo apellido</FormLabelView>
            </div>
            <div className="col-12 lg:col-7 mt-5 lg:mt-0">
              <FormInputView>{user.second_name}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-5 lg:pt-5 lg:pr-0">
              <FormLabelView>Tipo de documento</FormLabelView>
            </div>
            <div className="col-12 lg:col-7 mt-5 lg:mt-0">
              <FormInputView className="text-capitalize">{user.documentType?.name}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-5 lg:pt-5 lg:pr-0">
              <FormLabelView>Número de documento</FormLabelView>
            </div>
            <div className="col-12 lg:col-7 mt-5 lg:mt-0">
              <FormInputView>{user.document_number}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-5 lg:pt-5 lg:pr-0">
              <FormLabelView>Fecha de nacimiento</FormLabelView>
            </div>
            <div className="col-12 lg:col-7 mt-5 lg:mt-0">
              <FormInputView>{utils.getDateViewFormat(user.date_birth)}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-5 lg:pt-5 lg:pr-0">
              <FormLabelView>Previsión</FormLabelView>
            </div>
            <div className="col-12 lg:col-7 mt-5 lg:mt-0">
              <FormInputView>{user.forecast?.name}</FormInputView>
            </div>
          </div>
        </div>

        <div className="col-12 lg:col-6 lg:pl-40 mt-25 lg:mt-0">
          <div className="row">
            <div className="col-12 lg:col-3 lg:pt-5">
              <FormLabelView>E-mail</FormLabelView>
            </div>
            <div className="col-12 lg:col-9 mt-5 lg:mt-0">
              <FormInputView>{user.email}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-3 lg:pt-5">
              <FormLabelView>Teléfono</FormLabelView>
            </div>
            <div className="col-12 lg:col-9 mt-5 lg:mt-0">
              <FormInputView>{user.phone}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-3 lg:pt-5">
              <FormLabelView>Dirección</FormLabelView>
            </div>
            <div className="col-12 lg:col-9 mt-5 lg:mt-0">
              <FormInputView style={{ minHeight: '50px' }}>{user.address}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-3 lg:pt-5">
              <FormLabelView>Nacionalidad</FormLabelView>
            </div>
            <div className="col-12 lg:col-9 mt-5 lg:mt-0">
              <FormInputView>{user.nationality?.name}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-3 lg:pt-5">
              <FormLabelView>Región</FormLabelView>
            </div>
            <div className="col-12 lg:col-9 mt-5 lg:mt-0">
              <FormInputView>{user.region?.name}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-3 lg:pt-5">
              <FormLabelView>Provincia</FormLabelView>
            </div>
            <div className="col-12 lg:col-9 mt-5 lg:mt-0">
              <FormInputView>{user.city?.name}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-3 lg:pt-5">
              <FormLabelView>Comuna</FormLabelView>
            </div>
            <div className="col-12 lg:col-9 mt-5 lg:mt-0">
              <FormInputView>{user.commune?.name}</FormInputView>
            </div>
          </div>

          <div className="row mt-25">
            <div className="col-12 lg:col-3 lg:pt-5">
              <FormLabelView>Género</FormLabelView>
            </div>
            <div className="col-12 lg:col-9 mt-5 lg:mt-0">
              <FormInputView>{user.gender?.name}</FormInputView>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { ProfileView }